export const deTranslations = {
  loading: {
    message: 'Bleiben Sie verbunden, um die aktuellen Informationen zur Pannenhilfe live zu verfolgen'
  },
  not_found: {
    message: 'Es tut uns leid, dieses Fahrzeug ist uns nicht bekannt.'
  },
  beneficiary_location: {
    found: {
      message: 'Sie wurden an folgender Adresse lokalisiert:',
      address_inline: '{number} {street_name}, {city_zip} {city_name}, {country}'
    },
    sent: {
      title: 'Ihr Standort wurde gesendet',
      subtitle: 'Ihr Pannenhelfer wird bald eintreffen'
    },
    modify_btn_content: 'Ändern',
    confirm_btn_content: 'Ja, das ist die richtige Adresse',
    button_loading_content: 'GPS-Position wird berechnet',
    accuracy_estimate: 'Geschätzte Genauigkeit: ~{accuracy} m',
    ask: {
      underground_question: 'Befindet sich das Fahrzeug in einem Bereich mit Höhenbegrenzung?',
      underground_yes: 'Ja',
      underground_no: 'Nein',
      manual_fallback_info: 'Ihre GPS-Position konnte nicht ermittelt werden. Bitte geben Sie Ihre Adresse manuell ein.'
    }
  },
  manual_geolocation: {
    address_input_placeholder: 'Adresse hier eingeben...',
    save_btn_content: 'Speichern',
    cancel_btn_content: 'Abbrechen',
    title: 'Geben Sie Ihre genaue Position ein:'
  },
  share_position: {
    geolocation_refused: {
      ios_device: "Sie erlauben die Standortermittlung nicht. <a target='_blank' href='https://zupple.fr/go/faq/activer-la-geolocalisation-sous-ios/'>Hier finden Sie eine Anleitung, um die Standortermittlung auf Ihrem Gerät zu aktivieren.</a>",
      android_device: "Sie erlauben die Standortermittlung nicht. <a target='_blank' href='https://support.google.com/chrome/answer/142065?hl=de&co=GENIE.Platform%3DAndroid'>Hier finden Sie eine Anleitung, um die Standortermittlung auf Ihrem Gerät zu aktivieren.</a>",
      no_mobile_device: 'Sie erlauben die Standortermittlung nicht. Bitte aktivieren Sie sie, damit Ihr Pannenhelfer Sie lokalisieren kann'
    },
    geolocation_not_available: 'Fehler: Position konnte nicht ermittelt werden.',
    geolocation_too_long: 'Fehler: Das Abrufen der Position hat zu lange gedauert'
  },
  message_composer: {
    placeholder: 'Geben Sie Ihre Nachricht ein',
    submit: 'Senden'
  },
  truck_en_route: {
    tow_truck_image: {
      alt: 'Abschleppfahrzeug'
    },
    message_with_truck_image: 'Gute Nachrichten! {first_name}, einer unserer besten Pannenhelfer, ist auf dem Weg zu Ihnen. Bitte überprüfen Sie bei seiner Ankunft seine Identität anhand des Kennzeichens und des bereitgestellten Fahrzeugfotos.',
    message_without_truck_image: 'Gute Nachrichten! {first_name}, einer unserer besten Pannenhelfer, ist auf dem Weg zu Ihnen. Bitte überprüfen Sie bei seiner Ankunft seine Identität anhand des Kennzeichens.'
  },
  guided_depollution: {
    vehicle_photo_alt: 'Einsatzfahrzeug'
  },
  missions_infos: {
    driver_name: {
      title: 'Ihr Pannenhelfer'
    },
    company_name: {
      title: 'Ihr Pannendienst'
    }
  },
  notifications: {
    modal_title: 'Bleiben Sie informiert',
    prompt: 'Aktivieren Sie Benachrichtigungen, um sofort informiert zu werden, wenn Ihr Pannenhelfer Ihnen eine Nachricht sendet.',
    enable_button: 'Benachrichtigungen aktivieren',
    decline_button: 'Später'
  }
}
